import { Component, Input } from '@angular/core';
import { MidtermExamPaymentStatus } from '../../models/MidtermExamPayment';

@Component({
    selector: 'app-midterm-exam-payment-status',
    template: `
<span class="badge" *ngIf="value"
        [class.text-bg-warning]="value == 'Pending'"
        [class.text-bg-success]="value == 'Success'"
        [class.text-bg-danger]="value == 'Fail'">
    {{'midtermExamPayment_status' + value | translate}}
</span>
`
})
export class MidtermExamPaymentStatusComponent {
    @Input() value: MidtermExamPaymentStatus;
}
